import { ProductGroups } from 'enums';
import { getCoPilotTabRoutes } from 'features/co-pilot/co-pilot-routes';

import { Navigate, type RouteObject } from 'react-router';
import { NavigationStates } from 'stores/app-bar-navigation-store';

import { lazy } from 'react';

// Loaded on first use, like the pages in App.tsx; all tabs share one chunk.
const pages = () => import('./co-pilot-pages');
const CoPilotAccountsPage = lazy(() => pages().then(m => ({ default: m.CoPilotAccountsPage })));
const CoPilotCampaignDetailRedirect = lazy(() =>
  pages().then(m => ({ default: m.CoPilotCampaignDetailRedirect }))
);
const CoPilotBlacklistPage = lazy(() => pages().then(m => ({ default: m.CoPilotBlacklistPage })));
const CoPilotCampaignPage = lazy(() => pages().then(m => ({ default: m.CoPilotCampaignPage })));
const CoPilotNewCampaignPage = lazy(() =>
  pages().then(m => ({ default: m.CoPilotNewCampaignPage }))
);
const CoPilotInboxPage = lazy(() => pages().then(m => ({ default: m.CoPilotInboxPage })));
const CoPilotProjectsPage = lazy(() => pages().then(m => ({ default: m.CoPilotProjectsPage })));
const CoPilotStatisticsPage = lazy(() => pages().then(m => ({ default: m.CoPilotStatisticsPage })));
const CoPilotTasksPage = lazy(() => pages().then(m => ({ default: m.CoPilotTasksPage })));

export const getCoPilotChildRoutes = (productGroup: ProductGroups): RouteObject[] => {
  const tabRoutes = getCoPilotTabRoutes(productGroup);

  return [
    { index: true, element: <Navigate to={tabRoutes[NavigationStates.PROJECTS]} replace /> },
    { path: 'projects', element: <CoPilotProjectsPage /> },
    // Campaign detail is a real, linkable page. It renders inside the same co-pilot shell
    // so the navigation stays intact; the overview switches on the `campaignId` param.
    // It has to sit under `projects`, because the projects page is what renders the
    // overview component that reads that param.
    { path: 'projects/:campaignId', element: <CoPilotProjectsPage /> },
    { path: 'campaign', element: <CoPilotCampaignPage /> },
    { path: 'campaign/:campaignId', element: <CoPilotCampaignDetailRedirect /> },
    ...(productGroup === ProductGroups.HR_BOOSTER
      ? [
          // Der neue Flow „Neue Kampagne“ gilt nur für Recruiting; Sales behält den bisherigen Dialog + Builder.
          { path: 'new-campaign', element: <CoPilotNewCampaignPage /> },
          { path: 'new-campaign/:campaignId', element: <CoPilotNewCampaignPage /> },
        ]
      : []),
    { path: 'accounts', element: <CoPilotAccountsPage /> },
    { path: 'blacklist', element: <CoPilotBlacklistPage /> },
    { path: 'statistics', element: <CoPilotStatisticsPage /> },
    { path: 'inbox', element: <CoPilotInboxPage /> },
    { path: 'tasks', element: <CoPilotTasksPage /> },
  ];
};
